import { Box, Stack, Typography } from '@mui/material';
import { FC } from 'react';
import { TournamentTypes } from 'common';
import { PayoutCurrency } from 'common/dist/infrastructure/modules/game/interfaces/TournamentTypes';

import { useTranslationPrefix } from 'infrastructure/translations/i18n';
import { formatToCurrency } from 'targets/web/modules/display/utils/tournamentUtils';

interface TournamentCardBodyDetailsProps {
  tournament: TournamentTypes.TournamentConfig;
}

export const TournamentCardBodyDetails: FC<TournamentCardBodyDetailsProps> = ({ tournament }) => {
  const t = useTranslationPrefix('tournament');

  const getEntryFee = () => {
    if (tournament.buyIn === 0) {
      return (
        <>
          <Typography sx={{ fontFamily: 'RawsonBlack', fontSize: '36px', color: '#22C55E' }}>
            {t('free')}
          </Typography>
          <Typography sx={{ fontFamily: 'RawsonSemiBold', fontSize: '30px', color: '#E5E5E5' }}>
            {t('entry_fee')}
          </Typography>
        </>
      );
    }

    switch (tournament.currency) {
      case PayoutCurrency.CASH:
        return (
          <>
            <Typography sx={{ fontFamily: 'RawsonBlack', fontSize: '36px' }}>
              {formatToCurrency(tournament.buyIn)}
            </Typography>
            <Typography sx={{ fontFamily: 'RawsonSemiBold', fontSize: '30px', color: '#E5E5E5' }}>
              {t('entry_fee')}
            </Typography>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <Stack
      sx={{
        px: 6,
        height: 93,
        gap: 4,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}>
      <Stack
        sx={{
          flexDirection: 'row',
          gap: 2,
          alignItems: 'center',
          justifyContent: 'center',
          flex: 1,
        }}>
        <Typography sx={{ fontFamily: 'RawsonBlack', fontSize: '36px' }}>
          {tournament.playerCount}
        </Typography>
        <Typography sx={{ fontFamily: 'RawsonSemiBold', fontSize: '30px', color: '#E5E5E5' }}>
          {tournament.playerCount === 1 ? t('player') : t('players')}
        </Typography>
      </Stack>
      <Box sx={{ width: '1px', height: '45px', backgroundColor: '#525252' }}></Box>
      <Stack
        sx={{
          flexDirection: 'row',
          gap: 2,
          alignItems: 'center',
          justifyContent: 'center',
          flex: 1,
        }}>
        {getEntryFee()}
      </Stack>
      <Box sx={{ width: '1px', height: '45px', backgroundColor: '#525252' }}></Box>
      <Stack
        sx={{
          flexDirection: 'row',
          gap: 2,
          alignItems: 'center',
          justifyContent: 'center',
          flex: 1,
        }}>
        <Typography sx={{ fontFamily: 'RawsonBlack', fontSize: '36px' }}>
          {tournament.gameType}
        </Typography>
        <Typography sx={{ fontFamily: 'RawsonSemiBold', fontSize: '30px', color: '#E5E5E5' }}>
          {t('type')}
        </Typography>
      </Stack>
    </Stack>
  );
};
